export const stripe = {
  subTitle:
    "اربط حساب Stripe الخاص بك لتحصيل مدفوعات عملائك عن الحجوزات بسرعة وسهولة، متجنّبًا عمولات وكالات السفر عبر الإنترنت.",
};
